const changeUnit = (value: number) => {
    // console.log(values)
    const newValue = ['', '', '']
    if (value < 10000) {
        newValue[0] = value + ''
    } else if (value >= 10000 && value < 1000000) {
        newValue[0] = (parseFloat(String(value)) / 10000).toFixed(2) + ''
        newValue[1] = '万+'
    } else if (value >= 1000000 && value < 10000000) {
        newValue[0] = (parseFloat(String(value)) / 1000000).toFixed(0) + ''
        newValue[1] = '百万+'
    } else if (value >= 10000000 && value < 100000000) {
        newValue[0] = (parseFloat(String(value)) / 10000000).toFixed(0) + ''
        newValue[1] = '千万+'
    } else if (value >= 100000000) {
        newValue[0] = (parseFloat(String(value)) / 100000000).toFixed(0) + ''
        newValue[1] = '亿+'
    }
    // console.log(newValue)
    return newValue.join('')
    // const newValue = ['', '', '']
    let fr = 10000
    let num = 4
    let text1 = ''
    let fm = 1
    while (value / fr >= 1) {
        fr *= 10
        num += 1
        console.log('数字', value / fr, 'num:', num)
    }
    if (num <= 5) { // 千
        newValue[0] = value + ''
        // newValue[0] = parseInt(String(value / 1000), 0) + ''
        // newValue[1] = '千'
    } else if (num <= 8) { // 万
        text1 = parseInt(String(num - 5), 0) / 4 > 1 ? '千万' : '万'
        // tslint:disable-next-line:no-shadowed-variable
        fm = text1 === '万' ? 10000 : 10000000
        if (value % fm === 0) {
            newValue[0] = parseInt(String(value / fm), 0) + ''
        } else {
            newValue[0] = parseFloat(String(value / fm)).toFixed(2) + ''
        }
        newValue[1] = text1
    } else if (num <= 16) { // 亿
        text1 = (num - 8) / 3 > 1 ? '千亿' : '亿'
        text1 = (num - 8) / 4 > 1 ? '万亿' : text1
        text1 = (num - 8) / 7 > 1 ? '千万亿' : text1
        // tslint:disable-next-line:no-shadowed-variable
        fm = 1
        if (text1 === '亿') {
            fm = 100000000
        } else if (text1 === '千亿') {
            fm = 100000000000
        } else if (text1 === '万亿') {
            fm = 1000000000000
        } else if (text1 === '千万亿') {
            fm = 1000000000000000
        }
        if (value % fm === 0) {
            newValue[0] = parseInt(String(value / fm), 0) + ''
        } else {
            newValue[0] = parseFloat(String(value / fm)).toFixed(2) + ''
        }
        newValue[1] = text1
    }
    if (value < 1000) {
        newValue[0] = value + ''
        newValue[1] = ''
    }
    console.log(newValue)
    return newValue.join('')
// return 11
}
export default { changeUnit }
